import api from '../utilBackoffice';

const controller = 'Remessa3044';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  Download: dto => api.Axios.DownloadZipFile(url + '/Download', dto),
  Reprocessar: dto => api.Axios.Post(url + '/Reprocessar', dto)
});
